export default function Loader({...props}){
    return <div className="loader-post" style={{...props}}>
    </div>
}